import env from 'environments';
import getInstance from './instance';
import getJourneyInstance from './instanceJourney';

const instance = getInstance();
const journeyInstance = getJourneyInstance();

// hubspot-off-block-3 task 93: with VITE_WELCOME_JOURNEY_DISABLED on, the
// Welcome Journey calls below resolve locally and send no request, so the
// afy-welcome-journey service can be scaled to 0. The empty todos keep every
// `?welcomeJourney` branch inert; the write stand-ins carry no 201, so no
// caller marks a step as completed.
const isWelcomeJourneyDisabled = () => env.WELCOME_JOURNEY_DISABLED === true;
const EMPTY_TODOS = () => Promise.resolve({ data: [] });
const NO_CONTENT = () => Promise.resolve({ status: 204, data: {} });

export const fetchCountryList = () => {
  const url = '/country';

  return instance.get(url);
};

export const fetchStatesByCountryName = ({ country }) => {
  const url = '/state';
  const params = {
    country,
  };

  return instance.get(url, { params });
};

export const fetchJourneyTodos = async () => {
  if (isWelcomeJourneyDisabled()) return EMPTY_TODOS();
  const url = '/journey/fetch';
  try {
    const res = await journeyInstance.get(url);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * Completes the Welcome Journey "schedule coaching call" task for the logged-in
 * member (afy-welcome-journey `POST /journey/complete-scheduling-task`, matched
 * by the token's e-mail). Called by the "I booked my call — continue" button
 * while HubSpot Meetings is off, and by the staging/development auto-complete.
 */
export const completeSchedulingTask = async () => {
  if (isWelcomeJourneyDisabled()) return NO_CONTENT();
  const url = '/journey/complete-scheduling-task';
  try {
    return await journeyInstance.post(url);
  } catch (error) {
    console.error('Error completing scheduling task:', error);
    return Promise.reject(error);
  }
};

export const fetchSubscriptionJourney = async () => {
  if (isWelcomeJourneyDisabled()) return NO_CONTENT();
  const url = '/journey/fetch/subscription';
  try {
    const res = await journeyInstance.get(url);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postJourneyTodos = async (todos) => {
  if (isWelcomeJourneyDisabled()) return NO_CONTENT();
  const url = '/journey/complete/step';
  try {
    const res = await journeyInstance.post(url, todos);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const completeWelcomeJourney = async () => {
  if (isWelcomeJourneyDisabled()) return NO_CONTENT();
  const url = '/journey/complete-welcome-journey';
  try {
    const res = await journeyInstance.post(url);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};
